import './StyleGuide.css';
import React from 'react'

function FontGuide() {
  return (
    <div id="elements">
        <div className="style_header">Fonts</div>
        <div className='fonts'>
            <p className='medium'>The font used in the Gaggle Application is from the Sans Serif font family:</p>
            <p className="style_montserrat"> Montserrat </p>
            <p className='medium'>We use different weights throughout the application.</p>
            <p className='medium'>Titles and Headings are bold.</p>
            <p className='medium'>The rest of the text in the application has a medium weight.</p>
            <p className='medium'>General font colors are: White and Dark Blue.</p>
            <p className='head'>Titles/Headings: Montserrat - Bold </p>
            <p className='medium'>Normal text: Montserrat - Medium</p>
            <p className='medium'>Text might have a green or black drop-shadow depending on the background.</p>
            <p className='g_filter'>
                <br />
                Green [filter: drop-shadow(0.3em 0.3em 0.35em rgba(70,157,137,1));]
            </p>
            <p className='b_filter'>
                Black [filter: drop-shadow(0.3em 0.3em 0.35em rgba(0, 0, 0, 0.5))]
            </p>
        </div>
    </div>
  )
}

export default FontGuide